import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icons/Shield-success.svg'


const _withScopeId = n => (_pushScopeId("data-v-6c38dfce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "message__title-wrapper message__title-wrapper--purchase" }
const _hoisted_5 = { class: "message__section-title message__section-title--black" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 col-md-8 offset-md-2" }
const _hoisted_8 = { class: "message__wrapper" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message__subtitle-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "message__img",
    src: _imports_0,
    alt: "Операция прошла успешно",
    width: "100",
    height: "100"
  }),
  /*#__PURE__*/_createElementVNode("h3", { class: "message__title message__title--success" }, " Успешно! ")
], -1))
const _hoisted_10 = { class: "message__text-wrapper" }
const _hoisted_11 = { class: "message__text" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "message__text" }, " Уведомление о принятии заявки будет отправлено на адрес электронной почты контактного лица, а также можно ознакомиться в Личном кабинете в разделе Уведомления. ", -1))
const _hoisted_13 = { class: "message__button" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" В Актуальные конкурсы ")

import { useRoute } from 'vue-router';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'success-offer',
  setup(__props) {

const route = useRoute();

const lotId = ref(route?.query?.lotId || '');

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, " Заявка на участие в конкурсе №" + _toDisplayString(lotId.value), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("p", _hoisted_11, " Заявка на участие в конкурсе №" + _toDisplayString(lotId.value) + " успешно отправлена. ", 1),
            _hoisted_12
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_router_link, {
              to: { name: 'GenContractorLotsList' },
              class: "message__link"
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})